import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { convertLegacyEntityCardExtension } from '@backstage/plugin-catalog-react/alpha';
import {
  EntityAwsCodePipelineCard,
  isAwsCodePipelineAvailable,
} from '@aws/aws-codepipeline-plugin-for-backstage';

/**
 * AWS CodePipeline entity card. Same legacy bridge as aws-ecs — see that
 * module's header comment and docs/operations.md → "AWS Labs plugin suite".
 *
 * The plugin also exports `EntityAwsCodePipelineExecutionsContent` (a full
 * tab of past executions) — deliberately not wired this wave; the overview
 * card covers the "is the pipeline healthy" question this plugin was added
 * for, and a second entity-page surface can be added later if the card
 * proves insufficient.
 */
const awsCodePipelineEntityCard = convertLegacyEntityCardExtension(
  EntityAwsCodePipelineCard,
  {
    name: 'aws-codepipeline',
    filter: isAwsCodePipelineAvailable,
  },
);

export const awsCodePipelineModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [awsCodePipelineEntityCard],
});
